import * as React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ColorPicker from './ColorPicker';
import cloneDeep from 'lodash/cloneDeep';
import {Action} from '../../../system/buttons';
import {BasicFormElement} from '../../../system/form';

export class GaugeWidgetEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {...props.configuration};
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState !== this.state) {
      this.props.onUpdate(this.state);
    }
  }

  render() {
    console.debug(this.state);
    return (
      <>
        <Row>
          <Col md={1}>Section #</Col>
          <Col md={1}>BPM</Col>
          <Col md={4}>Color</Col>
        </Row>
        <Row>
          <Col>
            {this.state.ranges.map((range, index) => {
              return (
                <div key={index}>
                  <Row>&nbsp;</Row>
                  <Row>
                    <Col md={1}>{index + 1}</Col>
                    <Col md={1}>
                      <Form.Control
                        value={range.to}
                        type={'number'}
                        onChange={(e) => {
                          let ranges = cloneDeep(this.state.ranges);
                          ranges[index].to = parseInt(e.target.value);
                          if (this.getInvalidMessage(ranges)) {
                            alert(this.getInvalidMessage(ranges));
                          } else {
                            this.setState({ranges});
                          }
                        }}
                      ></Form.Control>
                    </Col>
                    <Col md={2}>
                      <ColorPicker
                        color={range.color}
                        onChangeComplete={(e) => {
                          let ranges = cloneDeep(this.state.ranges);
                          ranges[index].color = e;
                          this.setState({ranges});
                        }}
                      />
                    </Col>
                  </Row>
                </div>
              );
            })}
          </Col>
        </Row>

        <Row>
          <pre> </pre>
        </Row>
        <BasicFormElement label={'Flip horizontally'}>
          <Form.Check
            type="checkbox"
            onChange={(e) => this.setState({mirrored: e.target.checked})}
            checked={this.state.mirrored}
          />
        </BasicFormElement>

        <Row>
          <Action onClick={() => this.props.onSave(this.state)}>Save</Action>
        </Row>
      </>
    );
  }

  getInvalidMessage = (ranges) => {
    for (let i = 0; i < ranges.length; i++) {
      let {to} = ranges[i];
      if (i !== ranges.length - 1) {
        if (ranges[i + 1].to <= to) {
          return `Sections #${i + 1} and #${i + 2} are overlapping.`;
        }
      }
    }
  };
}
